@use 'styles/functions/rem' as *;

.confirmModal {
    align-items: center;
    background-color: var(--confirm-modal-overlay-background-color);
    display: flex;
    inset: 0;
    justify-content: center;
    position: fixed;
    z-index: var(--confirm-modal-overlay-z-index);
}

.card {
    background-color: var(--confirm-modal-card-background-color);
    border-radius: var(--confirm-modal-card-border-radius);
    box-shadow: var(--confirm-modal-card-box-shadow);
    display: flex;
    flex-direction: column;
    gap: var(--confirm-modal-card-gap);
    max-width: 90vw;
    padding: var(--confirm-modal-card-padding);
    width: var(--confirm-modal-card-width);
}

.title {
    color: var(--confirm-modal-title-color);
    font-size: var(--confirm-modal-title-font-size);
    font-weight: var(--confirm-modal-title-font-weight);
    margin: 0;
}

.message {
    color: var(--confirm-modal-message-color);
    font-size: var(--confirm-modal-message-font-size);
    line-height: var(--confirm-modal-message-line-height);
    margin: 0;
}

.actions {
    display: flex;
    gap: var(--confirm-modal-actions-gap);
    justify-content: flex-end;
}

.cancelButton {
    background-color: transparent;
    border: rem(1px) solid var(--confirm-modal-cancel-button-border-color);
    border-radius: var(--confirm-modal-button-border-radius);
    color: var(--confirm-modal-cancel-button-color);
    cursor: pointer;
    font-family: inherit;
    font-size: var(--confirm-modal-button-font-size);
    font-weight: var(--confirm-modal-button-font-weight);
    padding: var(--confirm-modal-button-padding);

    &:hover {
        background-color: var(--confirm-modal-cancel-button-hover-background-color);
    }
}

.confirmButton {
    background-color: var(--confirm-modal-confirm-button-background-color);
    border: none;
    border-radius: var(--confirm-modal-button-border-radius);
    color: var(--confirm-modal-confirm-button-color);
    cursor: pointer;
    font-family: inherit;
    font-size: var(--confirm-modal-button-font-size);
    font-weight: var(--confirm-modal-button-font-weight);
    padding: var(--confirm-modal-button-padding);

    &.destructive {
        background-color: var(--confirm-modal-destructive-background-color);
        color: var(--confirm-modal-destructive-color);
    }

    &:disabled {
        cursor: not-allowed;
        opacity: var(--confirm-modal-disabled-opacity);
    }

    &:hover:not(:disabled) {
        opacity: 0.9;
    }
}
